<template>
  <v-card dark class="edit qualification-type" v-if="qualificationType">
    <can I="edit" a="QualificationType">
      <v-card-title primary-title>
        <div v-if="qualificationType.id">
          <div class="headline">{{ qualificationType.name }}</div>
          <span class="subheading grey--text">
            {{ qualificationType.qualificationCategory.name }}
          </span>
        </div>
        <div v-else>
          New Qualification Type
        </div>
      </v-card-title>

      <v-alert color="error" transition="scale-transition" :value="qualificationType.errors">
        <ul><li v-for="(message, i) in qualificationType.errors" :key="`error-${i}`">{{ message }}</li></ul>
      </v-alert>

      <v-card-text>
        <v-form v-model="valid" @submit.prevent="submit">
          <v-select
            label="Category"
            v-model="qualificationType.qualificationCategory.id"
            :items="categories" item-text="name" item-value="id"
            required :rules="rules.qualificationCategory"
          />
          <v-text-field
            label="Name"
            v-model="qualificationType.name"
            required :rules="rules.name"
          />
          <v-text-field
            label="Acronym"
            v-model="qualificationType.acronym"
            :rules="rules.acronym"
          />
        </v-form>
      </v-card-text>

      <v-card-actions><v-spacer />
        <v-btn flat @click="$emit('cancel')" color="grey">Cancel</v-btn>
        <v-btn :disabled="!valid" @click="submit" color="primary">
          {{ qualificationType.id ? 'Update' : 'Create' }}
        </v-btn>
      </v-card-actions>
    </can>
  </v-card>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  created() {
    this.$store.dispatch('qualificationCategories/fetchAll')
  },
  data() {
    return {
      // Validations
      valid: !!this.$route.params.id,
      rules: {
        qualificationCategory: [v => !!v || 'You must provide a category'],
        name: [v => !!v || 'You must provide a name'],
        acronym: []
      }
    }
  },
  computed: {
    ...mapGetters({ categories: 'qualificationCategories/all' }),
    qualificationType() {
      return this.$store.getters['admin/qualificationTypes/find'](parseInt(this.$route.params.id))
    },
  },
  methods: {
    submit() {
      if (this.valid) this.$emit('update')
    },
  },
}
</script>
